const INIT_STATE = {
   isForwardVisible: true,
   isAskQuestionVisible: true,
   isPlanVisible: true,
   isToDoVisible: true
};
export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_VISIBILITY_OPTIONS":
         return {
            ...state,
            ...action.visibilityOptions
         };
      default:
         return state;
   }
};
